var _path, _path2, _rect, _g, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 257,
    viewBox: "0 0 626 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M564 36.1847C442.051 99.6609 239.514 174.485 0.5 193V223.5H564V36.1847Z",
    fill: "url(#paint0_linear_1325_368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M624.8 3.26866C625.501 2.82665 625.711 1.90034 625.269 1.19968C624.827 0.49902 623.9 0.28934 623.2 0.731344L624.8 3.26866ZM0.61585 194.496C284.878 172.475 517.61 70.8885 624.8 3.26866L623.2 0.731344C516.39 68.1115 284.122 169.525 0.38415 191.504L0.61585 194.496Z",
    fill: "url(#paint1_linear_1325_368)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 221,
    width: 624,
    height: 5,
    rx: 2.5,
    fill: "url(#paint2_linear_1325_368)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1325_368)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 223,
    r: 14,
    fill: "#7130C3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 223,
    r: 10,
    fill: "#7130C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 564,
    cy: 223,
    r: 5,
    fill: "#070710"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1325_368",
    x: 530,
    y: 189,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_1325_368"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1325_368",
    x1: 312.25,
    y1: 58,
    x2: 312.25,
    y2: 223.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7130C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1325_368",
    x1: 624,
    y1: 97.5,
    x2: 0.5,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1325_368",
    x1: -3.02613,
    y1: 222.807,
    x2: 110.394,
    y2: 472.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1066,
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5303,
    stopColor: "#7130C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9634,
    stopColor: "#410093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00EE",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3BD4",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeChart);
export default __webpack_public_path__ + "static/media/shape_chart.17af21f9b1c2dc3105bb423dae091c6b.svg";
export { ForwardRef as ReactComponent };